import { Skeleton } from 'primitives/skeleton'
import { TableHead, TableRow } from 'primitives/table'

interface SkeletonTableHeaderProps {
  columnCount: number
  cellWidths: string[]
  shrinkZero: boolean
}

export const SkeletonTableHeader = ({
  columnCount,
  cellWidths,
  shrinkZero,
}: SkeletonTableHeaderProps) => (
  <TableRow className="hover:bg-transparent">
    {Array.from({ length: columnCount }).map((_, j) => (
      <TableHead
        key={j}
        style={{
          width: cellWidths[j],
          minWidth: shrinkZero ? cellWidths[j] : 'auto',
        }}
      >
        <Skeleton className="h-6 w-full" />
      </TableHead>
    ))}
  </TableRow>
)
